import agent from "./agent";

export function getScreenList() {
  return agent.get("configs/screenList");
}

export function getRouterList() {
  return agent.get(`configs/routerList`);
}

export function getFCMTopicList() {
  return agent.get(`configs/fcmTopicList`);
}

export function addPushNotification(payload) {
  return agent.post("push-notifications/add", { ...payload });
}

export function updatePushNotification(id, payload) {
  return agent.put(`push-notifications/${id}/edit`, { ...payload });
}

export function getPushNotificationList({ filter = {}, skip = 0, limit = 10, sort = "createdDate DESC" }) {
  return agent.get("push-notifications/getList", {
    params: {
      filter,
      skip,
      limit,
      sort
    }
  });
}

export function getPushNotificationDetail(id) {
  return agent.get(`push-notifications/${id}/getDetail`);
}

export async function uploadFileSingle(file) {
  const formData = new FormData();
  formData.append('file', file);
  
  const res = await agent.post('/push-notifications/uploadFileSingle', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  
  return res.data;
}

export function deletePushNotification(id) {
  return agent.delete(`push-notifications/${id}`);
}
